/* eslint-disable */
// TODO: remove eslint-disable, fix errors
import * as fb from '@/library/firebase'
import router from '@/router'

export default {
  // sign user in
  async login({ dispatch }, form) {
    return new Promise((resolve, reject) => {
      let hasError
      fb.auth.signInWithEmailAndPassword(form.email, form.password)
        .then(userProfile => {
          resolve(userProfile)
        })
        .catch(error => {
          hasError = error
          reject(hasError)
        })
    })
  },
  // sign user up
  async signup({ commit, state }, data) {
    return new Promise(async (resolve, reject) => {
      // This object serves as the schema for the user object
      let userProfile = {
        dateCreated: Date.now(),
        email: data.email,
        firstName: data.firstName,
        lastName: data.lastName,
        password: data.password,
        uid: ''
      }

      if (data.isAdmin) {
        userProfile.isAdmin = true
      }
      else {
        userProfile = {
          ...userProfile,
          address1: data.address1 || '',
          address2: data.address2 || '',
          application: {
            asFiled: null,
            draft: null,
            draftFeedback: null,
            filingDate: null,
            filingReceipt: null,
            serialNumber: null,
            draftFeedback: null
          },
          businessName: data.businessName || '',
          certification1: data.certification1 || '',
          certification2: data.certification2 || '',
          city: data.city || '',
          clientNumber: null,
          coinventors: data.coinventors || '',
          competitors: data.knownCompetitors || '',
          consultationId: null,
          package: data.package || '',
          packageVariant: data.variantId || '',
          phone: data.phone || '',
          state: data.state || '',
          stripe: {
            customerId: null,
            customPrice: null,
            paymentMethodId: null,
            setupIntentClientSecret: null
          },
          supportingDetails: {
            inventionTitle: null,
            featuresOfInterest: null,
            figures: [],
            howInventionCanBeUsed: null,
            howInventionSolvesProblem: null,
            keyElement: null,
            problemToBeSolved: null
          },
          timelineStep: 0,
          zip: data.zip || ''
        }
      }

      try {
        // Create user in firebase auth
        const { user } = await fb.auth.createUserWithEmailAndPassword(userProfile.email, userProfile.password)

        // remove password since we won't be storing that in the user profile
        delete userProfile.password

        // store the unique ID in the user profile
        userProfile.uid = user.uid

        // send email to admin
        if (!data.simpleSignup) {
          const sendEmail = fb.funcs.httpsCallable('sendEmail')

          let to = state.adminEmail
          let subject = `User has registered with Portland Patent.`
          let link = `${process.env.VUE_APP_SITE_URL}/update-profile?uid=${userProfile.uid}`;
          let message = `<p>User account information for ${userProfile.firstName} ${userProfile.lastName}</p>`
          message += `<ul>`
          message += `<li>Username/Email: ${userProfile.email}</li>`
          message += `<li>Business Name: ${userProfile.businessName}</li>`
          message += `<li>Certification 1: ${userProfile.certification1}</li>`
          message += `<li>Certification 2: ${userProfile.certification2}</li>`
          message += `<li>Coinventors: ${userProfile.coinventors}</li>`
          message += `<li>Competitors: ${userProfile.competitors}</li>`
          message += `<li>Address: ${userProfile.address1}${userProfile.address2 ? ` ${userProfile.address2}` : ''}, ${userProfile.city}, ${userProfile.state} ${userProfile.zip}</li>`
          message += `<li>Phone: ${userProfile.phone}</li>`
          message += `<li>Package: ${userProfile.package}</li>`
          message += `<li>Package Variant: ${userProfile.packageVariant}</li>`
          message += `</ul>`
          message += `<p>View their profile here: <a href="${link}">${link}</a>.</p>`
          await sendEmail({ to, subject, message }).catch(() => {}) // TODO Handle email failure

          // send email to user
          to = userProfile.email
          subject = `Your Portland Patent account registration details`
          link = `${process.env.VUE_APP_SITE_URL}/update-profile`
          message = `<h1>Thank you for registering with Portland Patent!</h1>`
          message += `<p>Below is your account registration information with PortlandPatent.com.</p>`
          message += `<p>User account information for ${userProfile.firstName} ${userProfile.lastName}</p>`
          message += `<ul>`
          message += `<li>Username/Email: ${userProfile.email}</li>`
          message += `<li>Package: ${userProfile.package}</li>`
          if (userProfile.packageVariant) {
            message += `<li>Package Variant: ${userProfile.packageVariant}</li>`
          }
          message += `</ul>`
          message += `<p>Please check the registration details including name, address, payment details, and business name and business entity type if registering as a business.</p>`
          message += `<p>Please keep your username and password secure.</p>`
          message += `<p>You can edit your profile here: <a href="${link}">${link}</a></p>`

          await sendEmail({ to, subject, message }).catch(() => {}) // TODO Handle email failure
        }

        resolve(userProfile)
      }
      catch(e) {
        commit('setFireBaseAuthError', e)
        reject(e)
      }
    })
  },
  // fetch user profile
  async fetchUserProfile({ commit }, user) {
    const userProfile = await fb.usersCollection.doc(user.uid).get()
    const userProfileData = userProfile.data()

    if (!userProfileData) {
      fb.auth.signOut()
      return;
    }

    // Set user admin or no
    fb.auth.currentUser.getIdTokenResult()
      .then((idTokenResult) => {
        // Confirm the user is an Admin.
        if (idTokenResult.claims.admin  || userProfileData.isAdmin) {
          commit('setIsAdmin', true)
        } else {
          // Show regular user UI.
          commit('setIsAdmin', false)
        }
      })
      .catch((error) => {
        console.log(error)
      });

    // set user profile in state
    let profile = userProfile.data()
    if (profile) {
      profile.uid = user.uid
      profile.email = user.email
      commit('setUserProfile', profile)
    }

    // if route is signup or login change route to timeline because user is already logged in
    if (router.currentRoute.path === '/signup' || router.currentRoute.path === '/login') {
      router.push('/').catch(() => {})
    }
  },
  // log user out
  async logout({ commit }) {
    await fb.auth.signOut()

    // clear user data from state
    commit('setUserProfile', null)

    // redirect to login view
    router.push('/login')
  },
  // update user profile
  async updateProfile({ dispatch }, { form, formKey, uid }) {
    return new Promise(async (resolve, reject) => {
      // leave formKey blank to update entire profile
      if (form && uid) {
        let updateObject = {}
        if (formKey) {
          updateObject[formKey] = form
        }
        else {
          updateObject = form
        }

        // Update user email address if it needs to be updated
        if (updateObject.email) {
          const user = fb.auth.currentUser // TODO: this should get user from uid
          if (user.email !== updateObject.email) {
            const profileUpdateObject = {
              email: updateObject.email
            }
            await fb.funcs.httpsCallable('updateUser')({uid, properties: profileUpdateObject})
              .catch(function(error) {
                reject(error)
              })
          }
        }

        // Convert custom price to a number from a string
        if (updateObject?.stripe?.customPrice) {
          updateObject.stripe.customPrice = parseFloat(updateObject.stripe.customPrice)
        }

        // Remove password from update object so we don't save a plaintext password into user data
        delete updateObject.password
        delete updateObject.password_confirm
        delete updateObject?.supportingDetails?.document // TODO: figure out why null 'document' field is getting added

        fb.usersCollection.doc(uid).set(updateObject, { merge: true }).then(() => {
          resolve(updateObject)
        }).catch((error) => {
          reject(error)
        })
      }
    })
  },
  // set timeline step
  async setTimelineStep({ commit, state }, step) {
    const uid = state.queriedUserProfile ? state.queriedUserProfile.uid : state.userProfile.uid
    if (uid) {
      await fb.usersCollection.doc(uid).update({
        timelineStep: step
      })
      commit(state.queriedUserProfile ? 'setQueriedUserTimelineStep' : 'setUserTimelineStep', step)
    }
  },
  // get clients
  async getClients({ state }) {
    return new Promise(async (resolve, reject) => {
      let clients = []
      const snapshot = await fb.usersCollection.get()
      if (snapshot.empty) {
        reject('No users found')
      }

      snapshot.forEach(doc => {
        let client = doc.data()
        client.uid = doc.id
        if (doc.id !== state.userProfile?.uid && !client.isAdmin) {
          clients.push(client)
        }
      })

      clients.sort((a, b) => parseInt(b.dateCreated) - parseInt(a.dateCreated))

      resolve(clients)
    })
  }
}